import React, { ReactNode, useContext } from "react";

import { observer } from "mobx-react-lite";

import { createStyles, makeStyles } from "@material-ui/core";
import { SideMenu } from "../../SideMenu/SideMenu";
import { commonsStoreContext } from "../../../model/CommonsStore";
import { AutoBreadCrumbs } from "../../BreadCrumbs/BreadCrumbs";
import { UserMenu, UserMenuProps } from "../../UserMenu/UserMenu";
import { ConfirmationDialog } from "../../Dialog/ConfirmationDialog";

const useStyles = makeStyles(() =>
  createStyles({
    topRightUserActionButtons: {
      position: "absolute",
      top: 0,
      right: 0
    }
  })
);

export interface LayoutWithoutHeaderProps extends UserMenuProps {
  /** Breadcrumbs component */
  breadCrumbs?: ReactNode;
  /** A path to a branding logotype image */
  logo?: any;
  /** Side menu items */
  items: ReactNode;
  /** Application title */
  appTitle?: string;
  /** Optional custom landing page route, for logotype on click action */
  landingPageLink?: string;
  /** Used as container for main application content like views, most typically a router */
  children: ReactNode;
  /** Additional menu items in the top right corner of the layout */
  customMenuItems?: ReactNode;
}

/**
 * Layout without header at the top, instead top components are floating
 * */
export const LayoutWithoutHeader = observer(
  (props: LayoutWithoutHeaderProps) => {
    const commons = useContext(commonsStoreContext);
    const classes = useStyles();
    const {
      appTitle,
      breadCrumbs,
      children,
      customMenuItems,
      items,
      landingPageLink,
      logo,
      buttonConfig
    } = props;

    return (
      <>
        <SideMenu
          logoSrc={logo}
          landingPageLink={landingPageLink}
          items={items}
          expanded={commons.sideMenuDrawerExpanded}
          appTitle={appTitle}
        >
          {breadCrumbs ? breadCrumbs : <AutoBreadCrumbs />}
          <div className={classes.topRightUserActionButtons}>
            <UserMenu
              customMenuItems={customMenuItems}
              buttonConfig={buttonConfig}
            />
          </div>
          {children}
        </SideMenu>
        <ConfirmationDialog
          open={commons.dialogOpen}
          dialogProps={commons.dialogProps}
        />
      </>
    );
  }
);
